import Popover from "@mui/material/Popover";

import { IScheduleTablePopoverProps } from "@/shared/interfaces/schedulePage";
import calculateEndTime from "@/utils/timeCalc";
import priceFormatter from "@/utils/priceFormatter";
import pfoneFormatter from "@/utils/pfoneFormatter";
import { normalizeTime } from "@/utils/normalizeTime";
import getArraySum from "@/utils/getArraySum";
import { totalPriceCounter } from "@/services/API/totalPriceCounter";

import "./ScheduleTablePopover.scss";

export default function ScheduleTablePopover({
    open,
    anchorEl,
    handlePopoverClose,
    appointment,
}: IScheduleTablePopoverProps) {
    const {
        patientId,
        doctorId,
        startTime,
        duration,
        notes,
        services,
        paymentHistory,
    } = appointment;

    const patientName = patientId?.name || "Пацієнта видалено";
    const primaryPhone = patientId?.primaryPhone;
    const doctorName = doctorId?.name || "Лікаря видалено";
    const total = totalPriceCounter(services);

    const payments = getArraySum(paymentHistory || []);

    return (
        <Popover
            id='mouse-over-popover'
            disableScrollLock={true}
            sx={{ pointerEvents: "none", ml: 2 }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
        >
            <section className='popover_container'>
                <div className='popover_title_container'>
                    <img
                        className='popover_logo'
                        alt='logo'
                        src='scheduleTable/toust-popover.svg'
                    />
                    <div>
                        <p className='popover_title'>{patientName}</p>
                        <p className='popover_phone'>
                            {primaryPhone ? pfoneFormatter(primaryPhone) : ""}
                        </p>
                    </div>
                </div>
                <div className='popover_doctor_info popover_subdiv'>
                    <p className='popover_subtitle'>Лікар:</p>
                    <p className='popover_doctor_name'>{doctorName}</p>
                </div>
                <div className='popover_time_info popover_subdiv'>
                    <p className='popover_subtitle'>Час:</p>
                    <p className='popover_doctor_name'>
                        {startTime} -{" "}
                        {normalizeTime(calculateEndTime(startTime, duration))} (
                        {duration} хвилин)
                    </p>
                </div>
                <div className='popover_bill_info popover_subdiv'>
                    <div className='popover_total_sum popover_money'>
                        <p className='popover_subtitle'>Всього:</p>
                        <p className='popover_doctor_name'>
                            {priceFormatter(total)}₴
                        </p>
                    </div>
                    <div className='popover_total_debt popover_money'>
                        <p className='popover_subtitle'>Борг:</p>
                        <p className='popover_doctor_name'>
                            {priceFormatter(total - payments)}₴
                        </p>
                    </div>
                </div>
                <div className='popover_subdiv'>
                    <p className='popover_subtitle'>Примітки:</p>
                    <p className='popover_doctor_name'>
                        {notes ? notes : "примітки відсутні"}
                    </p>
                </div>
            </section>
        </Popover>
    );
}
